export default __webpack_public_path__ + "static/bgx-7c238463cf92c3956f2bf6779577ca6c.png";